<template>
  <div class="container" v-if="item">
    <div class="columns box-title is-12">
      <div class="column is-8">
        <h4 class="has-text-left">
          <i class="fal fa-box-check"></i>
          ລາຍລະອຽດການຢືນຢັນຮັບພັດສະດຸ
        </h4>
      </div>
      <div class="column is-4 has-text-right">
        <vs-button dark flat @click="goBack">
          <span style="margin-right: 8px"><i class="fal fa-arrow-left"></i></span>
          ກັບຄືນ
        </vs-button>
      </div>
    </div>

    <!-- ຫົວຂໍ້ບິນ -->
    <div class="head-card">
      <div class="head-left">
        <span class="head-label">ເລກພັດສະດຸ</span>
        <span class="head-no">{{ item.parcel_number }}</span>
      </div>
      <div class="head-route">
        <div class="route-node">
          <i class="fal fa-store"></i>
          <span class="route-name">{{ item.start_branch.name }}</span>
          <span class="route-prov">{{ item.start_branch.province.prefix }}</span>
          <span class="route-tag">ຕົ້ນທາງ</span>
        </div>
        <div class="route-line"><i class="fal fa-long-arrow-right"></i></div>
        <div class="route-node">
          <i class="fal fa-map-marker-alt"></i>
          <span class="route-name">{{ item.end_branch.name }}</span>
          <span class="route-prov">{{ item.end_branch.province.prefix }}</span>
          <span class="route-tag">ປາຍທາງ</span>
        </div>
      </div>
      <div class="head-right">
        <div class="status-pill" :class="statusMeta.cls">
          <i :class="statusMeta.icon"></i>
          {{ statusMeta.name }}
        </div>
        <span class="head-date">
          <i class="fal fa-calendar-alt"></i> {{ formatDateTime(item.created_at) }}
        </span>
      </div>
    </div>

    <div class="columns">
      <!-- ຮູບພາບ -->
      <div class="column is-7">
        <div class="panel">
          <h5 class="panel-title">
            <i class="fal fa-images"></i> ຮູບພາບພັດສະດຸ
            <span class="panel-sub">({{ item.images.length }} ຮູບ — ກົດທີ່ຮູບເພື່ອເບິ່ງເຕັມຈໍ)</span>
          </h5>
          <div class="gallery">
            <div
                class="gallery-item"
                v-for="(img, i) in item.images"
                :key="img.id"
                @click="openLightbox(i)">
              <img :src="img.image_url" :alt="img.caption"/>
              <span class="gallery-zoom"><i class="fal fa-search-plus"></i></span>
              <span class="gallery-caption">{{ img.caption }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ຂໍ້ມູນ -->
      <div class="column is-5">
        <div class="panel">
          <h5 class="panel-title"><i class="fal fa-user"></i> ຂໍ້ມູນຜູ້ຮັບ</h5>
          <div class="info-row"><span>ຊື່ຜູ້ຮັບ</span><b>{{ item.receiver.name }}</b></div>
          <div class="info-row"><span>ເບີໂທ</span><b>{{ item.receiver.tel }}</b></div>
        </div>

        <div class="panel">
          <h5 class="panel-title"><i class="fal fa-box"></i> ຂໍ້ມູນພັດສະດຸ</h5>
          <div class="info-row"><span>ປະເພດ</span><b>{{ item.parcel.category }}</b></div>
          <div class="info-row"><span>ຈຳນວນ</span><b>{{ item.parcel.quantity }} ຊິ້ນ</b></div>
          <div class="info-row"><span>ນ້ຳໜັກ</span><b>{{ item.parcel.weight }} kg</b></div>
          <div class="info-row"><span>ຍອດ COD</span><b>{{ money(item.parcel.cod) }} ₭</b></div>
          <div class="info-row"><span>ໝາຍເຫດ</span><b>{{ item.remark || "----" }}</b></div>
        </div>

        <div class="panel">
          <h5 class="panel-title"><i class="fal fa-history"></i> ປະຫວັດການດຳເນີນການ</h5>
          <ul class="timeline">
            <li v-for="(t, i) in timeline" :key="i" :class="t.tone">
              <span class="tl-dot"><i :class="t.icon"></i></span>
              <div class="tl-body">
                <b>{{ t.title }}</b>
                <span>{{ t.desc }}</span>
                <em>{{ formatDateTime(t.date) }}</em>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ປຸ່ມດຳເນີນການ -->
    <div class="action-bar" v-if="item.status !== 'confirmed'">
      <vs-button success @click="onConfirm">
        <span style="margin-right: 8px"><i class="fal fa-check"></i></span>
        ຢືນຢັນຮັບພັດສະດຸ
      </vs-button>
      <vs-button danger flat v-if="item.status !== 'rejected'" @click="showReject = true">
        <span style="margin-right: 8px"><i class="fal fa-times"></i></span>
        ປະຕິເສດຮັບ
      </vs-button>
    </div>

    <!-- ເຫດຜົນປະຕິເສດ -->
    <div class="panel reject-panel" v-if="showReject">
      <h5 class="panel-title"><i class="fal fa-comment-alt-exclamation"></i> ເຫດຜົນການປະຕິເສດ</h5>
      <textarea class="input reject-input" rows="3" v-model="rejectReason"
                placeholder="ລະບຸເຫດຜົນ.."></textarea>
      <div class="reject-actions">
        <vs-button danger :disabled="!rejectReason.trim()" @click="onReject">ຢືນຢັນປະຕິເສດ</vs-button>
        <vs-button dark flat @click="showReject = false">ຍົກເລີກ</vs-button>
      </div>
    </div>

    <!-- Lightbox -->
    <div v-if="lightbox.open" class="lightbox" @click.self="closeLightbox">
      <button class="lb-close" @click="closeLightbox"><i class="fal fa-times"></i></button>
      <button class="lb-nav lb-prev" v-if="item.images.length > 1" @click.stop="prevImage">
        <i class="fal fa-chevron-left"></i>
      </button>
      <div class="lb-content" @click.stop>
        <img :src="currentImage.image_url" :alt="currentImage.caption"/>
        <div class="lb-caption">
          <strong>{{ item.parcel_number }}</strong>
          <span>{{ currentImage.caption }}</span>
          <span class="lb-index">{{ lightbox.index + 1 }} / {{ item.images.length }}</span>
        </div>
      </div>
      <button class="lb-nav lb-next" v-if="item.images.length > 1" @click.stop="nextImage">
        <i class="fal fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <div class="container" v-else>
    <div class="empty-state">
      <i class="fal fa-inbox"></i>
      <p>ບໍ່ພົບຂໍ້ມູນພັດສະດຸນີ້</p>
      <vs-button dark flat @click="goBack">ກັບຄືນ</vs-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import router from "@/router";
import {
  confirmReceive,
  getReceiveParcel,
  getStatusMeta,
  rejectReceive,
} from "@/views/SuperAdmin/ConfirmReceiveParcel/demoData";

export default {
  data: () => ({
    item: null,
    showReject: false,
    rejectReason: "",
    lightbox: {open: false, index: 0},
  }),

  computed: {
    statusMeta() {
      return getStatusMeta(this.item ? this.item.status : "");
    },
    currentImage() {
      if (!this.item) return {};
      return this.item.images[this.lightbox.index] || {};
    },
    timeline() {
      if (!this.item) return [];
      const tl = [
        {
          title: "ຮັບເຂົ້າລະບົບ",
          desc: `ສ້າງລາຍການຈາກສາຂາ ${this.item.start_branch.name}`,
          date: this.item.created_at,
          icon: "fal fa-inbox-in",
          tone: "tone-default",
        },
      ];
      if (this.item.status === "checking") {
        tl.push({
          title: "ກຳລັງກວດສອບ",
          desc: this.item.remark || "ພະນັກງານກຳລັງກວດສອບພັດສະດຸ",
          date: this.item.created_at,
          icon: "fal fa-search",
          tone: "tone-info",
        });
      }
      if (this.item.confirmed_at) {
        tl.push({
          title: "ຢືນຢັນຮັບພັດສະດຸ",
          desc: `ໂດຍ ${this.item.confirmed_by ? this.item.confirmed_by.name : "—"}`,
          date: this.item.confirmed_at,
          icon: "fal fa-check",
          tone: "tone-ok",
        });
      }
      if (this.item.rejected_at) {
        tl.push({
          title: "ປະຕິເສດຮັບ",
          desc: this.item.reject_reason || "—",
          date: this.item.rejected_at,
          icon: "fal fa-times",
          tone: "tone-bad",
        });
      }
      return tl;
    },
  },

  methods: {
    money(v) {
      return this.$helpers ? this.$helpers.numberFormatter(v || 0) : (v || 0).toLocaleString();
    },
    formatDateTime(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm") : "----";
    },
    goBack() {
      router.push({name: "confirmReceiveParcel.index"}).catch(() => {
      });
    },
    load() {
      this.item = getReceiveParcel(this.$route.params.id);
    },
    onConfirm() {
      const updated = confirmReceive(this.$route.params.id, "Admin");
      if (updated) this.item = updated;
      this.showReject = false;
    },
    onReject() {
      const updated = rejectReceive(this.$route.params.id, this.rejectReason.trim(), "Admin");
      if (updated) this.item = updated;
      this.showReject = false;
      this.rejectReason = "";
    },
    openLightbox(i) {
      this.lightbox = {open: true, index: i};
      document.body.style.overflow = "hidden";
    },
    closeLightbox() {
      this.lightbox.open = false;
      document.body.style.overflow = "";
    },
    nextImage() {
      this.lightbox.index = (this.lightbox.index + 1) % this.item.images.length;
    },
    prevImage() {
      const len = this.item.images.length;
      this.lightbox.index = (this.lightbox.index - 1 + len) % len;
    },
    onKeydown(e) {
      if (!this.lightbox.open) return;
      if (e.key === "Escape") this.closeLightbox();
      if (e.key === "ArrowRight") this.nextImage();
      if (e.key === "ArrowLeft") this.prevImage();
    },
  },

  created() {
    this.load();
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 40px;
}

/* ---------------- head ---------------- */
.head-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 18px 22px;
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 10px;
  margin-bottom: 16px;
}

.head-left {
  display: flex;
  flex-direction: column;
}

.head-label {
  font-size: 12px;
  color: #8a8f99;
}

.head-no {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: .6px;
  color: #2b2f36;
}

.head-route {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.route-node {
  display: flex;
  flex-direction: column;
  align-items: center;

  i {
    font-size: 18px;
    color: #667;
  }
}

.route-name {
  font-weight: 600;
  color: #2b2f36;
}

.route-prov {
  font-size: 11px;
  color: #8a8f99;
}

.route-tag {
  margin-top: 2px;
  padding: 1px 8px;
  border-radius: 8px;
  background: #eef1f5;
  color: #667;
  font-size: 10px;
}

.route-line {
  color: #b9bec6;
  font-size: 22px;
}

.head-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  margin-left: auto;
}

.head-date {
  font-size: 12px;
  color: #8a8f99;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 30px;
  color: #fff;
  font-size: 13px;
  background: #b0b0b0;

  &.st-pending {
    background: #f39c12;
  }

  &.st-checking {
    background: #0652DD;
  }

  &.st-confirmed {
    background: #009432;
  }

  &.st-rejected {
    background: #e21312;
  }
}

/* ---------------- panels ---------------- */
.panel {
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #2b2f36;
  margin-bottom: 12px;

  i {
    margin-right: 6px;
    color: #667;
  }
}

.panel-sub {
  font-size: 12px;
  font-weight: 400;
  color: #9aa0a8;
  margin-left: 6px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px dashed #eef0f4;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }

  span {
    color: #8a8f99;
  }

  b {
    color: #2b2f36;
    text-align: right;
  }
}

/* ---------------- gallery ---------------- */
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.gallery-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e3e6ec;
  background: #f4f5f7;

  img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    display: block;
    transition: transform .25s ease;
  }

  .gallery-zoom {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    font-size: 24px;
    opacity: 0;
    transition: opacity .2s ease;
  }

  .gallery-caption {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 5px 8px;
    background: rgba(0, 0, 0, .6);
    color: #fff;
    font-size: 11px;
  }

  &:hover {
    img {
      transform: scale(1.06);
    }

    .gallery-zoom {
      opacity: 1;
    }
  }
}

/* ---------------- timeline ---------------- */
.timeline {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    position: relative;
    display: flex;
    gap: 12px;
    padding: 0 0 16px 0;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      left: 13px;
      top: 28px;
      bottom: 0;
      width: 2px;
      background: #e6e9ef;
    }
  }
}

.tl-dot {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b9bec6;
  color: #fff;
  font-size: 12px;
}

.tone-info .tl-dot {
  background: #0652DD;
}

.tone-ok .tl-dot {
  background: #009432;
}

.tone-bad .tl-dot {
  background: #e21312;
}

.tl-body {
  display: flex;
  flex-direction: column;
  font-size: 13px;

  b {
    color: #2b2f36;
  }

  span {
    color: #7a7f88;
  }

  em {
    color: #a5aab2;
    font-style: normal;
    font-size: 11px;
    margin-top: 2px;
  }
}

/* ---------------- actions ---------------- */
.action-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.reject-panel {
  border-left: 4px solid #e21312;
}

.reject-input {
  width: 100%;
  resize: vertical;
  padding: 8px 10px;
}

.reject-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.empty-state {
  padding: 60px 0;
  text-align: center;
  color: #9aa0a8;

  i {
    font-size: 46px;
    display: block;
    margin-bottom: 10px;
  }
}

/* ---------------- lightbox ---------------- */
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, .88);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lb-content {
  max-width: 78vw;
  text-align: center;

  img {
    max-width: 78vw;
    max-height: 72vh;
    border-radius: 8px;
    background: #fff;
  }
}

.lb-caption {
  margin-top: 12px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 14px;

  span {
    color: #cfd3da;
  }

  .lb-index {
    color: #8d949e;
    font-size: 12px;
  }
}

.lb-close {
  position: absolute;
  top: 20px;
  right: 26px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.lb-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  font-size: 22px;
  cursor: pointer;
}

.lb-prev {
  left: 24px;
}

.lb-next {
  right: 24px;
}
</style>
